import React, { useRef, useEffect, useState } from "react";
import Header from "../../Components/Header/header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useLocation } from "react-router-dom";
import { faEdit, faTrash, faEye } from "@fortawesome/free-solid-svg-icons";
import "./orgsetup.css";
import { FaEdit, FaTrash } from "react-icons/fa";
import Footer from "../../Components/Footer/footer";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";


const OrgSetup = () => {
    const [employees, setEmployees] = useState([]);
    const [submittedEmployees, setSubmittedEmployees] = useState([]);
    const [fileName, setFileName] = useState("");
    const [orgName, setOrgName] = useState("");
    const [orgAddress, setOrgAddress] = useState("");
    const [logoFile, setLogoFile] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [editingOrgId, setEditingOrgId] = useState(null);
    const [employeeList, setEmployeeList] = useState([]);
    const [loadingEmployeeList, setLoadingEmployeeList] = useState(true);
    const [organizations, setOrganizations] = useState([]);
    const [selectedOrgId, setSelectedOrgId] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const [orgPhno, setOrgPhno] = useState("");
    const [orgEmail, setOrgEmail] = useState("");
    const [orgGstNo, setOrgGstNo] = useState("");
    const [isFormDirty, setIsFormDirty] = useState(false);
    const [employeesSubmitted, setEmployeesSubmitted] = useState(false);
    const [isViewOnly, setIsViewOnly] = useState(false);
    const [showEditPopup, setShowEditPopup] = useState(false);
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [orgCategories, setOrgCategories] = useState("");
    const [categories, setCategories] = useState([]); // all system categories
    const [isEditing, setIsEditing] = useState(false);
    const [savedCategories, setSavedCategories] = useState([]);
    const [typingTimer, setTypingTimer] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [count, setCount] = useState("");
    const [rows, setRows] = useState([]);
    const [categoriesFromServer, setCategoriesFromServer] = useState([]); // org-specific categories
    const [showCategorySection, setShowCategorySection] = useState(true);
    const [columnList, setColumnList] = useState([]);
    const [selectedColumns, setSelectedColumns] = useState([]);
    const [showTemplatePopup, setShowTemplatePopup] = useState(false);
const orgPanRef = useRef(null);
    // NEW states for mapping mismatched categories
    const [fileParsedEmployees, setFileParsedEmployees] = useState([]); // employees parsed from file before mapping
    const [fileCategoryValues, setFileCategoryValues] = useState([]); // unique category values found in the file
    const [mismatchedCategories, setMismatchedCategories] = useState([]); // values from file that don't match org categories
    const [categoryMappings, setCategoryMappings] = useState({}); // { originalValue: { type: 'existing'|'create', cat_id?, cat_org_custom_name? , new_custom_name? } }
    const [showCategoryMatchPopup, setShowCategoryMatchPopup] = useState(false);
    const [mappingLoading, setMappingLoading] = useState(false);
    const [orgPanNumber, setOrgPanNumber] = useState("");

    // Add at the top of your component
    const [showApprovalPopup, setShowApprovalPopup] = useState(false);
    const [managerEmail, setManagerEmail] = useState("");
    const [approvalSubmitting, setApprovalSubmitting] = useState(false);
    const [newOrgData, setNewOrgData] = useState(null);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    
    // At the top of your component, after state declarations
    const employeesToDisplay = submittedEmployees.length > 0 ? submittedEmployees : employeeList;
    const routerLocation = useLocation();
    const org = routerLocation.state?.org;
    const orgId = selectedOrgId || org?.org_id;
    const location = useLocation();

    
    const excelHeaders = [
        "emp_id",
        "emp_email_id",
        "emp_name",
        "insured_name",
        "joining_date",
        "designation",
        "phone_number",
        "gender",
        "dob",
        "age",
        "sum_insured",
        "sum_insured_bal",
        "policy_start_date",
        "policy_end_date",
        "emp_status",
        "relation",
        "last_working_date",
    ];


    const REQUIRED_COLUMNS = [
        "emp_email_id",
        "emp_name",
        "joining_date",
        "designation",
        "dob",
        "emp_status",
        "relation",
        "insured_name",
        "cat_org_custom_name"
    ];

    const hasMinimumColumns = selectedColumns.length >= 9;

    const hasAllRequiredColumns = REQUIRED_COLUMNS.every(col =>
        selectedColumns.includes(col)
    );

    const isTemplateValid = hasMinimumColumns && hasAllRequiredColumns;


    const handleEditEmployee = (emp) => {
        setSelectedEmployee(emp);
        setShowEditPopup(true);
    };

    // Fetch saved employee list
    useEffect(() => {
        const fetchEmployeeList = async () => {
            try {
                const orgId = selectedOrgId || routerLocation.state?.org?.org_id;
                if (!orgId) return;

                const res = await fetch(`/api/employee-list?org_id=${orgId}`);
                const data = await res.json();

                // Ensure it's an array
                const employeeArray = Array.isArray(data) ? data : [];
                setEmployeeList(employeeArray);
            } catch (err) {
                console.error("Error fetching employee list:", err);
            } finally {
                setLoadingEmployeeList(false);
            }
        };
        fetchEmployeeList();
    }, []);


    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const res = await fetch("/api/categories");
                const data = await res.json();
                setCategories(data || []);
            } catch (error) {
                console.error("Error loading categories:", error);
                alert("Error loading categories");
            }
        };
        fetchCategories();
    }, []);

    useEffect(() => {
        const orgId = selectedOrgId || location.state?.org?.org_id || localStorage.getItem("selectedOrgId");
        if (orgId) {
            setSelectedOrgId(orgId); // ensure state is set
            fetchOrgCategories(orgId);
        }
    }, [selectedOrgId, location.state]);

    const filteredCategories = categoriesFromServer.filter(
        (cat) => cat.org_id == selectedOrgId
    );
    const fetchAllCategories = async () => {
        try {
            const res = await fetch("/api/categories");
            const data = await res.json();
            setCategories(data);
        } catch (error) {
            console.error("Error fetching categories:", error);
            setCategories([]);
        }
    };

    const fetchOrganizations = async () => {
        try {
            const res = await fetch("/api/organizations");
            const data = await res.json();
            setOrganizations(data);
        } catch (err) {
            console.error("Error fetching organizations:", err);
        }
    };

    const fetchColumns = async () => {
        const response = await fetch("/api/employee-columns");
        const data = await response.json();
        setColumnList(data);
    };

   
    const handleCheckboxChange = (column) => {
        setSelectedColumns(prev => {
            if (prev.includes(column)) {
                return prev.filter(item => item !== column);
            }
            return [...prev, column];
        });
    };

    

    const parseDate = (val) => {
        if (!val) return null;

        // Case 1: Excel serial number
        if (!isNaN(val)) {
            const date = new Date((val - 25569) * 86400 * 1000);
            return date.toISOString().split("T")[0];
        }

        // Case 2: String date like "10-06-1988" or "20/10/2025"
        if (typeof val === "string") {
            let parts;
            if (val.includes("-")) parts = val.split("-");
            else if (val.includes("/")) parts = val.split("/");

            if (parts?.length === 3) {
                // detect dd-mm-yyyy or dd/mm/yyyy
                if (parts[2].length === 4) {
                    const [dd, mm, yyyy] = parts;
                    return `${yyyy}-${mm.padStart(2, "0")}-${dd.padStart(2, "0")}`;
                }
                // yyyy-mm-dd
                if (parts[0].length === 4) return val;
            }

            const d = new Date(val);
            return isNaN(d) ? null : d.toISOString().split("T")[0];
        }

        return null;
    };

    const handleCategoryClick = (categoryName) => {
        setSelectedCategory(categoryName);
    };

    // Filter employees based on selected category
    const employeesInCategory = selectedCategory
        ? employeesToDisplay.filter(
            (emp) => (emp.cat_org_custom_name || emp.category_name || "Uncategorized") === selectedCategory
        )
        : [];


    const handleInputChange = (setter) => (e) => {
        setter(e.target.value);
        setIsFormDirty(true);
    };

    const calculateAge = (dob) => {
        if (!dob) return "";
        const birthDate = new Date(dob);
        const diffMs = Date.now() - birthDate.getTime();
        const ageDt = new Date(diffMs);
        return Math.abs(ageDt.getUTCFullYear() - 1970);
    };

    const handleCountChange = (num) => {
        setCount(num);

        if (!num) {
            setRows([]);
            return;
        }

        if (num > remainingCategories.length) {
            alert(
                `You selected ${num} but only ${remainingCategories.length} categories are available.`
            );
            setRows([]);
            return;
        }

        const selectedCategories = remainingCategories.slice(0, num);

        const rowArray = selectedCategories.map(cat => ({
            cat_id: cat.cat_id,
            cat_name: cat.cat_name,
            custom_name: ""
        }));

        setRows(rowArray);
    };

    const handleRowChange = (index, field, value) => {
        const updatedRows = [...rows];
        updatedRows[index][field] = value;
        setRows(updatedRows);
    };

    useEffect(() => {
        const org = location.state?.org;
        const viewOnly = location.state?.viewOnly || false;

        if (org) {
            setEditingOrgId(org.org_id);
            setOrgName(org.org_name || "");
            setOrgAddress(org.org_address || "");
            setOrgPhno(org.org_phno || "");
            setOrgEmail(org.org_email || "");
            setOrgGstNo(org.org_gstno || "");
            setOrgPanNumber(org.pan_number || "");
            setIsViewOnly(viewOnly);
        }
    }, [location.state]);

    // Fetch org employees & dependents when editing/viewing an existing org
    useEffect(() => {
        const org = location.state?.org;
        if (org) {
            setEditingOrgId(org.org_id);
            setOrgName(org.org_name || "");
            setOrgAddress(org.org_address || "");
            setOrgPhno(org.org_phno || "");
            setOrgEmail(org.org_email || "");
            setOrgGstNo(org.org_gstno || "");
            setOrgPanNumber(org.pan_number || "");

            // Fetch employees
            fetchEmployeeData(org.org_id);

            // ✅ Fetch saved categories
            fetch(`/api/org/${org.org_id}/saved-categories`)
                .then((res) => res.json())
                .then((data) => {
                    if (data.length > 0) {
                        setSavedCategories(data); // populate table
                        setShowCategorySection(false); // hide dropdown/input
                    }
                })
                .catch((err) => console.error("Error fetching saved categories:", err));
        }
    }, [location.state?.org?.org_id]);

    const fetchEmployeeData = (orgId) => {
        fetch(`/api/org-employees/${orgId}`, {
            method: "POST",
        })
            .then((res) => res.json())
            .then((data) => {
                const mergedData = [];
                data.employees?.forEach((emp) =>
                    mergedData.push({ ...emp, relation: "Employee" })
                );
                data.spouses?.forEach((sp) =>
                    mergedData.push({ ...sp, relation: "Spouse" })
                );
                data.children?.forEach((ch) =>
                    mergedData.push({ ...ch, relation: "Child" })
                );
                data.parents?.forEach((p) =>
                    mergedData.push({ ...p, relation: "Parent" })
                );
                data.inlaws?.forEach((il) =>
                    mergedData.push({ ...il, relation: "In-Law" })
                );

                const finalData = mergedData.map((emp) => ({
                    ...emp,
                    age: emp.dob ? calculateAge(emp.dob) : "",
                }));

                setSubmittedEmployees(finalData);
            })
            .catch((err) => console.error("❌ Error fetching employees:", err));
    };

    const handleDownload = () => {
        const link = document.createElement("a");
        link.href =
            process.env.PUBLIC_URL +
            "/Templates/blukuploadofemp/Add_employee_data_template..xlsx";
        link.download = "Employee_Template.xlsx";
        link.click();
    };

    const remainingCategories = categories.filter(
        cat => !categoriesFromServer.some(orgCat => orgCat.cat_id === cat.cat_id)
    );
    const handleEditCategory = (cat) => {
        setShowCategorySection(true);

        setRows([
            {
                cat_id: cat.cat_id,
                cat_name: cat.cat_name,
                custom_name: cat.cat_org_custom_name || ""
            }
        ]);

        setCount(1);
    };
    const handleDeleteCategory = async (catId) => {
        const orgId = selectedOrgId || location.state?.org?.org_id;
        if (!orgId) return alert("Organization not found");

        if (!window.confirm("Are you sure you want to delete this category?")) return;

        try {
            await fetch(`/api/categories/${catId}?org_id=${orgId}`, {
                method: "DELETE",
            });

            await fetchOrgCategories(orgId);

            alert("🗑️ Category deleted successfully");
        } catch (error) {
            console.error(error);
            alert("❌ Error deleting category");
        }
    };

    
    const fetchOrgCategories = async (orgId) => {
        try {
            const res = await fetch(`/api/organization/${orgId}/categories`);
            const data = await res.json();

            if (res.ok && data.success) {
                setCategoriesFromServer(data.categories || []);
                setShowCategorySection(true); // Always show dropdown
            } else {
                setCategoriesFromServer([]);
                setShowCategorySection(true);
            }
        } catch (error) {
            console.error("Error fetching org categories:", error);
            setCategoriesFromServer([]);
            setShowCategorySection(true);
        }
    };

    const getEmployeeSummary = (employeeList) => {
        const summaryMap = {};

        employeeList.forEach((emp) => {
            const key = emp.cat_org_custom_name || emp.category_name || "Uncategorized";


            if (!summaryMap[key]) {
                summaryMap[key] = 0;
            }

            summaryMap[key]++;
        });

        return Object.entries(summaryMap).map(([name, count]) => ({
            cat_org_custom_name: name,
            count: count,
        }));
    };

    const handleLogoUpload = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        setLogoFile(file);
    };

    // Step 1: Save Org
    const handleOrgSubmit = async (e) => {
        e.preventDefault();

        const emailRegex = /^[^\s@]+@[^\s@]+\.com$/;

        if (!emailRegex.test(orgEmail)) {
            alert('Email field – Validation to be done for "@" and "."; emails can end with ".co.in", ".xyz", etc.');
            return;
        }


        if (!orgName || !orgAddress) {
            alert("Please fill organization details.");
            return;
        }

        setIsSubmitting(true);

        try {
            const formData = new FormData();
            if (logoFile) formData.append("logo", logoFile);
            formData.append("org_name", orgName);
            formData.append("org_address", orgAddress);
            formData.append("org_phno", orgPhno);
            formData.append("org_email", orgEmail);
            formData.append("org_gstno", orgGstNo);
            formData.append("pan_number", orgPanNumber);
            let url = "/api/org";
            let method = "POST";

            // ✅ If editing existing org
            if (editingOrgId) {
                url = `/api/org/${editingOrgId}`;
                method = "PUT";
            }

            const res = await fetch(url, {
                method,
                body: formData,
            });

            const text = await res.text();
            let data;
            try {
                data = JSON.parse(text);
            } catch (err) {
                throw new Error("Invalid server response");
            }

            if (res.ok && data.success) {
                alert(editingOrgId ? "✅ Organization updated successfully!" : "✅ Organization created successfully!");

                setSelectedOrgId(data.data?.org_id || editingOrgId);
                localStorage.setItem("selectedOrgId", data.data?.org_id || editingOrgId);

                setIsFormDirty(false);
                fetchOrganizations();
                if (!editingOrgId) {
                    setNewOrgData(data.data); // store new org data
                    setShowApprovalPopup(true);
                }
            } else {
                alert("❌ Failed to save organization: " + (data.error || data.message || "Unknown error"));
            }
        } catch (err) {
            console.error("Error saving/updating org:", err);
            alert("Error saving organization. Check console for details.");
        } finally {
            setIsSubmitting(false);
        }
    };

    const detectCategoryField = (row) => {
        const possibleKeys = ["cat_org_custom_name", "cat_name", "categories", "category", "grade", "Cat", "Category"];
        for (const k of possibleKeys) {
            if (Object.prototype.hasOwnProperty.call(row, k)) return k;
        }
        return null;
    };

   
    // const handleFileUpload = (e) => {
    //     const file = e.target.files[0];
    //     if (!file) return;
    //     setFileName(file.name);

    //     const reader = new FileReader();
    //     reader.onload = (event) => {
    //         const data = new Uint8Array(event.target.result);
    //         const workbook = XLSX.read(data, { type: "array" });
    //         const sheet = workbook.Sheets[workbook.SheetNames[0]];
    //         const jsonData = XLSX.utils.sheet_to_json(sheet, { defval: "" });

    //         // normalize dates and compute age
    //         const parsedData = jsonData.map((row) => {
    //             const dateFields = [
    //                 "joining_date",
    //                 "dob",
    //                 "policy_start_date",
    //                 "policy_end_date",
    //                 "last_working_date",
    //             ];
    //             dateFields.forEach((field) => {
    //                 if (row[field]) row[field] = parseDate(row[field]);
    //             });
    //             row.age = calculateAge(row.dob);
    //             return row;
    //         });

    //         // detect category field name from first row
    //         const sampleRow = parsedData[0] || {};
    //         const categoryField = detectCategoryField(sampleRow);

    //         // gather unique category values from file (if any)
    //         const fileCatsSet = new Set();
    //         if (categoryField) {
    //             parsedData.forEach((r) => {
    //                 const v = (r[categoryField] || "").toString().trim();
    //                 if (v) fileCatsSet.add(v);
    //             });
    //         }

    //         const fileCats = Array.from(fileCatsSet);

    //         // Compare with org categories (we'll use cat_org_custom_name if present, else cat_name)
    //         const orgCatNames = (categoriesFromServer || []).map((c) =>
    //             (c.cat_org_custom_name && c.cat_org_custom_name.toString().trim()) ||
    //             (c.cat_name && c.cat_name.toString().trim()) ||
    //             ""
    //         );

    //         // find values in file that are not present in orgCatNames
    //         const mismatches = fileCats.filter((v) => !orgCatNames.includes(v));

    //         if (mismatches.length > 0) {
    //             // Save parsed file and mismatches and show mapping popup
    //             setFileParsedEmployees(parsedData);
    //             setFileCategoryValues(fileCats);
    //             setMismatchedCategories(mismatches);
    //             // initialize default mappings: map to 'create' by default
    //             const initialMappings = {};
    //             mismatches.forEach((m) => {
    //                 initialMappings[m] = { type: "create", original: m, new_custom_name: m };
    //             });
    //             setCategoryMappings(initialMappings);
    //             setShowCategoryMatchPopup(true);
    //             // Do not set employees yet — wait until mapping resolved
    //         } else {
    //             // no mismatches — set employees directly and include category field if present
    //             // but ensure we store cat_org_custom_name property on rows if field present
    //             const withCatName = parsedData.map((r) => {
    //                 const catField = detectCategoryField(r);
    //                 if (catField) {
    //                     return { ...r, cat_org_custom_name: r[catField] || "" };
    //                 }
    //                 return r;
    //             });
    //             setEmployees(withCatName);
    //             setFileParsedEmployees([]); // clear
    //             setMismatchedCategories([]);
    //             setCategoryMappings({});
    //         }
    //     };
    //     reader.readAsArrayBuffer(file);
    // };

    // Called when user resolves mappings in the popup
    
    const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const expectedHeaders = [
        "emp_id",
        "emp_email_id",
        "emp_name",
        "joining_date",
        "insured_name",
        "phone_number",
        "gender",
        "dob",
        "relation",
        "policy_start_date",
        "policy_end_date",
        "designation",
        "emp_status",
        "cat_org_custom_name"
    ];

    setFileName(file.name);

    const reader = new FileReader();

    reader.onload = (event) => {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheet = workbook.Sheets[workbook.SheetNames[0]];

        // ✅ STEP 1: Get headers only
        const headerRow = XLSX.utils.sheet_to_json(sheet, {
            header: 1
        })[0] || [];

        const uploadedHeaders = headerRow.map(h =>
            h?.toString().trim().toLowerCase()
        );

        const normalizedExpected = expectedHeaders.map(h =>
            h.toLowerCase()
        );

        // ✅ STEP 2: Validate headers
        const isValid =
            normalizedExpected.length === uploadedHeaders.length &&
            normalizedExpected.every((h, i) => h === uploadedHeaders[i]);

        if (!isValid) {
            alert("❌ Wrong template! Please download the correct Excel format.");
            setEmployees([]);
            setFileName("");
            return;
        }

        // ✅ STEP 3: Continue your existing logic (NO CHANGE)
        const jsonData = XLSX.utils.sheet_to_json(sheet, { defval: "" });

        const parsedData = jsonData.map((row) => {
            const dateFields = [
                "joining_date",
                "dob",
                "policy_start_date",
                "policy_end_date",
                "last_working_date",
            ];
            dateFields.forEach((field) => {
                if (row[field]) row[field] = parseDate(row[field]);
            });
            row.age = calculateAge(row.dob);
            return row;
        });

        const sampleRow = parsedData[0] || {};
        const categoryField = detectCategoryField(sampleRow);

        const fileCatsSet = new Set();
        if (categoryField) {
            parsedData.forEach((r) => {
                const v = (r[categoryField] || "").toString().trim();
                if (v) fileCatsSet.add(v);
            });
        }

        const fileCats = Array.from(fileCatsSet);

        const orgCatNames = (categoriesFromServer || []).map((c) =>
            (c.cat_org_custom_name && c.cat_org_custom_name.toString().trim()) ||
            (c.cat_name && c.cat_name.toString().trim()) ||
            ""
        );

        const mismatches = fileCats.filter((v) => !orgCatNames.includes(v));

        if (mismatches.length > 0) {
            setFileParsedEmployees(parsedData);
            setFileCategoryValues(fileCats);
            setMismatchedCategories(mismatches);

            const initialMappings = {};
            mismatches.forEach((m) => {
                initialMappings[m] = { type: "create", original: m, new_custom_name: m };
            });

            setCategoryMappings(initialMappings);
            setShowCategoryMatchPopup(true);
        } else {
            const withCatName = parsedData.map((r) => {
                const catField = detectCategoryField(r);
                if (catField) {
                    return { ...r, cat_org_custom_name: r[catField] || "" };
                }
                return r;
            });

            setEmployees(withCatName);
            setFileParsedEmployees([]);
            setMismatchedCategories([]);
            setCategoryMappings({});
        }
    };

    reader.readAsArrayBuffer(file);
};
    
    
    const handleResolveMappings = async () => {
        if (!selectedOrgId) {
            alert("Please save/select the organization first.");
            return;
        }

        setMappingLoading(true);

        try {
            const newCategoriesCreated = [];

            const mappingEntries = Object.entries(categoryMappings); // [ [originalValue, mappingObj], ... ]

            for (const [originalValue, mappingObj] of mappingEntries) {
                if (mappingObj.type === "existing") {
                    const existing = categoriesFromServer.find((c) => c.cat_id === mappingObj.cat_id);
                    if (existing) {
                        mappingObj.resolvedName = (existing.cat_org_custom_name && existing.cat_org_custom_name.trim()) || existing.cat_name;
                    } else {
                        mappingObj.resolvedName = mappingObj.cat_org_custom_name || originalValue;
                    }
                } else {
                    const payload = {
                        cat_name: originalValue,
                        cat_org_custom_name: mappingObj.new_custom_name || originalValue,
                        org_id: selectedOrgId,
                    };

                    const res = await fetch(`/api/organization/${selectedOrgId}/categories`, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify(payload),
                    });

                    const created = await res.json();
                    // Expect created to return the new category. If your backend returns different shape adapt here.
                    if (res.ok && created && (created.category || created.data || created.success)) {
                        // try to normalize the returned category object
                        const returnedCat = created.category || created.data || created;
                        // add to categoriesFromServer (so dropdowns will show it)
                        newCategoriesCreated.push(returnedCat);
                        mappingObj.resolvedName = returnedCat.cat_org_custom_name || returnedCat.cat_name || mappingObj.new_custom_name || originalValue;
                        mappingObj.cat_id = returnedCat.cat_id || returnedCat.id;
                        // Note: if API does not return category object, you may need to fetch categories again after loop
                    } else {
                        // fallback: treat as created with provided name
                        mappingObj.resolvedName = mappingObj.new_custom_name || originalValue;
                    }
                }
            }
            if (newCategoriesCreated.length === 0) {
                await fetchOrgCategories(selectedOrgId);
            } else {
                // merge with existing list
                setCategoriesFromServer((prev) => [...prev, ...newCategoriesCreated]);
            }
            const sampleRow = fileParsedEmployees[0] || {};
            const categoryField = detectCategoryField(sampleRow) || "categories";

            const updatedEmployees = fileParsedEmployees.map((row) => {
                const cellVal = (row[categoryField] || "").toString().trim();
                if (categoryMappings[cellVal]) {
                    // set standardized cat_org_custom_name
                    return { ...row, cat_org_custom_name: categoryMappings[cellVal].resolvedName || categoryMappings[cellVal].new_custom_name || cellVal };
                }
                // if no mapping (e.g., empty value), preserve existing or blank
                return { ...row, cat_org_custom_name: row[categoryField] || "" };
            });

            setEmployees(updatedEmployees);
            setShowCategoryMatchPopup(false);
            setFileParsedEmployees([]);
            setMismatchedCategories([]);
            setCategoryMappings({});
            alert("✅ Category mappings applied. You can now submit the employee data.");
        } catch (error) {
            console.error("Error resolving mappings:", error);
            alert("❌ Error while creating categories or applying mappings. See console.");
        } finally {
            setMappingLoading(false);
        }
    };

    const handleMappingChange = (originalValue, newMapping) => {
        setCategoryMappings((prev) => ({
            ...prev,
            [originalValue]: {
                ...(prev[originalValue] || {}),
                ...newMapping,
            },
        }));
    };

    // const handleSubmit = async (e) => {
    //     e.preventDefault();

    //     if (!selectedOrgId) {
    //         alert("Please save organization details first.");
    //         return;
    //     }

    //     if (employees.length === 0) {
    //         alert("Please upload employee Excel data before submitting.");
    //         return;
    //     }

    //     // Basic validation: ensure each employee has cat_org_custom_name set (or allow blank)
    //     const missingCategoryRows = employees.filter((emp) => !emp.cat_org_custom_name || emp.cat_org_custom_name.toString().trim() === "");
    //     if (missingCategoryRows.length > 0) {
    //         const proceed = window.confirm(`${missingCategoryRows.length} rows have no category assigned. Do you want to continue?`);
    //         if (!proceed) return;
    //     }

    //     setIsSubmitting(true);

    //     try {
    //         // ✅ Upload employees for existing organization
    //         const empRes = await fetch(
    //             `/api/organization/${selectedOrgId}/employees`,
    //             {
    //                 method: "POST",
    //                 headers: {
    //                     "Content-Type": "application/json",
    //                 },
    //                 body: JSON.stringify({
    //                     org_id: selectedOrgId,
    //                     employees: employees,
    //                 }),
    //             }
    //         );

    //         const empResult = await empRes.json();

    //         if (!empRes.ok || !empResult.success) {
    //             throw new Error(empResult.error || "Failed to save employees");
    //         }

    //         alert(`✅ Employees uploaded successfully for Org ID: ${selectedOrgId}`);
    //         setEmployeesSubmitted(true);

    //         // 🔄 Refresh employee data for current org
    //         fetchEmployeeData(selectedOrgId);

    //         // 🧹 Reset form state (optional)
    //         setFileName("");
    //         setEmployees([]);
    //         setShowPopup(false);
    //     } catch (error) {
    //         console.error("❌ Error submitting employees:", error);
    //         alert("❌ Failed to upload employee data");
    //     } finally {
    //         setIsSubmitting(false);
    //     }
    // };

// FRONTEND - handleSubmit

const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedOrgId) {
        alert("Please save organization details first.");
        return;
    }

    if (employees.length === 0) {
        alert("Please upload employee Excel data before submitting.");
        return;
    }

    const missingCategoryRows = employees.filter(
        (emp) =>
            !emp.cat_org_custom_name ||
            emp.cat_org_custom_name.toString().trim() === ""
    );

    if (missingCategoryRows.length > 0) {
        const proceed = window.confirm(
            `${missingCategoryRows.length} rows have no category assigned. Do you want to continue?`
        );

        if (!proceed) return;
    }

    setIsSubmitting(true);

    try {
        const empRes = await fetch(
            `/api/organization/${selectedOrgId}/employees`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    org_id: selectedOrgId,
                    employees: employees,
                }),
            }
        );

        const empResult = await empRes.json();

        // ✅ Show simple user-friendly backend reason
        if (!empRes.ok || !empResult.success) {
            let message =
                empResult.message ||
                empResult.error ||
                "Failed to upload employee data";

            // ✅ Priority: Employee duplicate first
            if (
                message.includes("employee_list") ||
                message.includes("duplicate key") ||
                message.includes("employee already exists")
            ) {
                message = "Employee details already exist.";
            }
            // ✅ Then spouse
            else if (message.includes("unique_org_emp_spouse")) {
                message = "Spouse details already exist for this employee.";
            }
            // ✅ Child
            else if (message.includes("unique_org_emp_child")) {
                message = "Child details already exist for this employee.";
            }
            // ✅ Parents
            else if (message.includes("unique_org_emp_parents")) {
                message = "Parent details already exist for this employee.";
            }
            // ✅ In-laws
            else if (message.includes("unique_org_emp_inlaws")) {
                message = "In-law details already exist for this employee.";
            }

            alert(message);
            return;
        }

        alert(`✅ Employees uploaded successfully for Org ID: ${selectedOrgId}`);

        setEmployeesSubmitted(true);

        // Refresh employee data
        fetchEmployeeData(selectedOrgId);

        // Reset popup state
        setFileName("");
        setEmployees([]);
        setShowPopup(false);

    } catch (error) {
        console.error("❌ Error submitting employees:", error);

        let errorMessage =
            error.message || "Failed to upload employee data";

        // ✅ Priority: Employee duplicate first
        if (
            errorMessage.includes("employee_list") ||
            errorMessage.includes("duplicate key") ||
            errorMessage.includes("employee already exists")
        ) {
            errorMessage = "Employee details already exist.";
        }
        // ✅ Then spouse
        else if (errorMessage.includes("unique_org_emp_spouse")) {
            errorMessage = "Spouse details already exist for this employee.";
        }
        // ✅ Child
        else if (errorMessage.includes("unique_org_emp_child")) {
            errorMessage = "Child details already exist for this employee.";
        }
        // ✅ Parents
        else if (errorMessage.includes("unique_org_emp_parents")) {
            errorMessage = "Parent details already exist for this employee.";
        }
        // ✅ In-laws
        else if (errorMessage.includes("unique_org_emp_inlaws")) {
            errorMessage = "In-law details already exist for this employee.";
        }

        alert(errorMessage);
    } finally {
        setIsSubmitting(false);
    }
};



    const handleOrgCatSave = async () => {
        const orgId = selectedOrgId || location.state?.org?.org_id;
        if (!orgId) return alert("Organization not found!");

        for (const row of rows) {
            if (!row.custom_name) return alert("Please fill all custom names");
        }

        try {
            for (const row of rows) {
                await fetch(`/api/categories/${row.cat_id}`, {
                    method: "PUT",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        cat_org_custom_name: row.custom_name,
                        org_id: orgId
                    }),
                });
            }

            // Refresh categories from server
            await fetchOrgCategories(orgId);

            // Reset inputs
            setRows([]);
            setCount("");

            alert("✅ Categories updated successfully!");
        } catch (error) {
            console.error(error);
            alert("❌ Error updating categories");
        }
    };

    const handleSendApproval = async (orgData) => {
        if (!orgData || !managerEmail) return;

        setApprovalSubmitting(true);

        try {
            const res = await fetch("/api/org/send-approval", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    manager_email: managerEmail,
                    org_id: orgData.org_id,
                    org_name: orgData.org_name,
                    org_email: orgData.org_email,
                    org_phno: orgData.org_phno,
                    org_address: orgData.org_address,
                }),
            });

            const data = await res.json();

            if (data.success) {
                alert("✅ Approval email sent successfully!");
                setShowApprovalPopup(false);
                setManagerEmail("");
                setNewOrgData(null);
            } else {
                alert("❌ Failed to send approval email: " + (data.error || "Unknown error"));
            }
        } catch (err) {
            console.error("Error sending approval email:", err);
            alert("❌ Error sending approval email. Check console.");
        } finally {
            setApprovalSubmitting(false);
        }
    };

    const handleUpdateEmployee = async (emp) => {
        try {
            const response = await fetch(
                `/api/organization/${emp.org_id}/employee/${emp.emp_id}`,
                {
                    method: "PUT",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(emp),
                }
            );

            const data = await response.json();
            if (data.success) {
                alert("✅ Employee updated successfully!");
                setShowEditPopup(false);
                fetchEmployeeData(); // refresh table
            } else {
                alert(data.message || "Update failed");
            }
        } catch (error) {
            console.error("Error updating employee:", error);
            alert("Server error while updating employee");
        }
    };

    return (
        <div className="orgsetup-page">
            <aside className="sidebar">
                <Header />
            </aside>

            <main className="orgsetup-content">
                <h2>Organization Setup</h2>

                <div className="org-form card">
                    <div className="form-row">
                        <div className="form-group">
                            <label>Logo:</label>
                            <input
                                type="file"
                                required
                                accept="image/*"
                                onChange={(e) => {
                                    handleLogoUpload(e);
                                    setIsFormDirty(true);
                                }}
                            />
                        </div>

                        <div className="form-group">
                            <label>Organization Name:</label>
                            <input
                                type="text"
                                required
                                value={orgName}
                                onChange={handleInputChange(setOrgName)}
                                placeholder="Enter organization name"
                                disabled={isViewOnly}
                            />
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="form-group">
                            <label>Organization Address:</label>
                            <input
                                type="text"
                                required
                                value={orgAddress}
                                onChange={handleInputChange(setOrgAddress)}
                                placeholder="Enter organization address"
                                disabled={isViewOnly}

                                maxLength={255}
                            />

                        </div>

                        <div className="form-group">
                            <label>Organization Phone:</label>
                            <input
                                type="text"
                                required
                                value={orgPhno}
                                onChange={(e) => {
                                    const onlyNums = e.target.value.replace(/\D/g, "");
                                    setOrgPhno(onlyNums);
                                    setIsFormDirty(true); // <-- mark form as dirty
                                }}

                                placeholder="Enter organization phone number"
                                disabled={isViewOnly}
                                maxLength={10}
                            />

                        </div>
                    </div>

                    <div className="form-row">
                        <div className="form-group">
                            <label>Organization Email:</label>
                            <input
                                type="email"
                                required
                                value={orgEmail}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    const atCount = (value.match(/@/g) || []).length;
                                    if (atCount <= 1) {
                                        setOrgEmail(value);
                                        setIsFormDirty(true);
                                    }
                                }}
                                placeholder="Enter organization email"
                                disabled={isViewOnly}
                            />
                        </div>

                        <div className="form-group">
                            <label>GST Number:</label>
                            <input
                                type="text"
                                required
                                value={orgGstNo}
                                onChange={(e) => {
                                    // Limit to 15 characters
                                    const value = e.target.value.toUpperCase(); 
                                    if (value.length <= 15) {
                                        setOrgGstNo(value);
                                        setIsFormDirty(true);
                                    }
                                }}
                                placeholder="Enter GST Number"
                                disabled={isViewOnly}
                                maxLength={15}
                            />

                        </div>
                        <div className="form-group">
                            <label>Organization PAN Number: <span style={{ color: "red" }}>*</span></label>
                            <input
                                type="text"
                                value={orgPanNumber}
                                onChange={handleInputChange(setOrgPanNumber)}
                                className={editingOrgId ? "highlight-input" : ""}
                                ref={orgPanRef} // optional ref if needed
                                placeholder="Enter PAN (e.g. ABCDE1234F)"
                            />
                        </div>
                    </div>

                    {(isFormDirty || editingOrgId) && (
                        <div className="org-update-banner">
                            <button
                                className="org-submit-btn top-btn"
                                onClick={handleOrgSubmit}
                                disabled={isSubmitting}
                            >
                                {editingOrgId ? "Update Organization" : "Save Organization"}
                            </button>
                        </div>
                    )}

                    {showCategorySection && (
                        <div className="category-section">
                            <h2>Customize employee category</h2>

                            <div className="category-count-row">
                                <label>How many categories do you want to Create?</label>
                                <select
                                    value={count}
                                    onChange={(e) => handleCountChange(Number(e.target.value))}
                                >
                                    <option value="">-- Select Count --</option>
                                    {[...Array(10)].map((_, i) => (
                                        <option key={i + 1} value={i + 1}>{i + 1}</option>
                                    ))}
                                </select>
                            </div>

                            {rows.length > 0 && (
                                <div className="category-grid">
                                    {rows.map((row, index) => (
                                        <div className="category-row" key={index}>
                                            <div className="category-info">
                                                <label>Category:</label>
                                                <span>{row.cat_name}</span>
                                            </div>
                                            <div className="category-input">
                                                <label>Custom Name:</label>
                                                <input
                                                    type="text"
                                                    value={row.custom_name}
                                                    onChange={(e) => handleRowChange(index, "custom_name", e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    ))}

                                    <button
                                        className="category-save-btn"
                                        onClick={handleOrgCatSave}
                                    >
                                        Save All
                                    </button>
                                </div>
                            )}
                        </div>
                    )}



                    {filteredCategories.length > 0 && (
                        <div className="saved-categories-table">
                            <h3>Selected Categories</h3>
                            <table>
                                <thead>
                                    <tr>
                                        
                                        <th>Custom Name</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredCategories
                                        .filter(cat => cat && cat.cat_id && cat.cat_org_custom_name) // <-- filter invalid rows
                                        .map((cat) => (
                                            <tr key={cat.cat_id}>
                                                <td>{cat.cat_org_custom_name}</td>
                                                <td style={{ textAlign: "center" }}>
                                                    <FaEdit
                                                        style={{ cursor: "pointer", marginRight: "12px", color: "#007bff" }}
                                                        title="Edit"
                                                        onClick={() => handleEditCategory(cat)}
                                                    />
                                                    <FaTrash
                                                        style={{ cursor: "pointer", color: "#dc3545" }}
                                                        title="Delete"
                                                        onClick={() => handleDeleteCategory(cat.cat_id)}
                                                    />
                                                </td>
                                            </tr>
                                        ))}
                                    {filteredCategories.filter(cat => cat && cat.cat_id && cat.cat_org_custom_name).length === 0 && (
                                        <tr>
                                            <td colSpan={2} style={{ textAlign: "center", fontStyle: "italic" }}>
                                                No categories found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>

                            </table>
                        </div>
                    )}


                    {selectedOrgId && !isFormDirty && !employeesSubmitted && (
                        <div className="org-add-employee-section">
                            <button
                                className="add-employee-btn"
                                onClick={() => setShowPopup(true)}
                            >
                                ➕ Add Employees
                            </button>
                        </div>
                    )}

                    {showPopup && (
                        <div className="employee-popup-overlay">
                            <div className="employee-popup-container">
                                <div className="employee-popup-header">
                                    <h3>Upload Employee Master Data</h3>
                                    <span
                                        className="employee-close-icon"
                                        onClick={() => setShowPopup(false)}
                                    >
                                        &#10005;
                                    </span>
                                </div>

                                <p className="employee-popup-subtitle">
                                    Download the template, fill employee details, and upload the Excel file.
                                </p>

                                <div className="employee-popup-actions">
                                    

                                    <button
                                        className="employee-btn employee-download"
                                        onClick={handleDownload}
                                    >
                                        Download Template
                                    </button>

                                    <label className="employee-btn employee-upload">
                                        Upload Excel
                                        <input
                                            type="file"
                                            accept=".xls,.xlsx"
                                            onChange={handleFileUpload}
                                            hidden
                                        />
                                    </label>
                                </div>

                                {fileName && (
                                    <p className="employee-file-name">
                                        Uploaded: {fileName}
                                    </p>
                                )}

                                <div className="employee-popup-footer">
                                    <button
    className={`employee-btn employee-submit ${
        employees.length === 0 || isSubmitting ? "org-disabled-btn" : ""
    }`}
    onClick={handleSubmit}
    disabled={employees.length === 0 || isSubmitting}
>
    {isSubmitting ? "Submitting..." : "Done"}
</button>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* MAPPING POPUP: shown when uploaded file has categories not present in org */}
                    {showCategoryMatchPopup && (
                        <div className="employee-popup-overlay">
                            <div className="employee-popup-container">
                                <div className="employee-popup-header">
                                    <h3>Category Mismatch Detected</h3>
                                    <span
                                        className="employee-close-icon"
                                        onClick={() => {
                                            // cancel mapping and reset upload
                                            setShowCategoryMatchPopup(false);
                                            setFileParsedEmployees([]);
                                            setFileCategoryValues([]);
                                            setMismatchedCategories([]);
                                            setCategoryMappings({});
                                            setFileName("");
                                        }}
                                    >
                                        &#10005;
                                    </span>
                                </div>

                                <p className="employee-popup-subtitle">
                                    The uploaded file contains category values that are not present for this organization.
                                    Please map them to an existing category or create a new category for the org.
                                </p>

                                <div style={{ maxHeight: 320, overflowY: "auto", padding: "8px" }}>
                                    {mismatchedCategories.map((orig) => (
                                        <div key={orig} style={{ marginBottom: 12, borderBottom: "1px solid #eee", paddingBottom: 8 }}>
                                            <div><strong>Value in file:</strong> {orig}</div>

                                            <div style={{ marginTop: 6 }}>
                                                <label style={{ display: "block", marginBottom: 4 }}>Map to existing category:</label>
                                                <select
                                                    value={categoryMappings[orig]?.type === "existing" ? categoryMappings[orig].cat_id || "" : ""}
                                                    onChange={(e) => {
                                                        const val = e.target.value;
                                                        if (!val) {
                                                            // choose create option
                                                            handleMappingChange(orig, { type: "create", new_custom_name: orig });
                                                        } else {
                                                            const catIdNum = isNaN(val) ? val : Number(val);
                                                            const existing = categoriesFromServer.find((c) => c.cat_id === catIdNum);
                                                            handleMappingChange(orig, { type: "existing", cat_id: catIdNum, resolvedName: existing?.cat_org_custom_name || existing?.cat_name });
                                                        }
                                                    }}
                                                >
                                                    <option value="">-- Create new (use file value) --</option>
                                                    {categoriesFromServer.map((c) => (
                                                        <option key={c.cat_id} value={c.cat_id}>
                                                            {(c.cat_org_custom_name && c.cat_org_custom_name) || c.cat_name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div style={{ marginTop: 8 }}>
                                                <label style={{ display: "block", marginBottom: 4 }}>If creating new, custom name (editable):</label>
                                                <input
                                                    type="text"
                                                    value={categoryMappings[orig]?.new_custom_name || orig}
                                                    onChange={(e) => handleMappingChange(orig, { type: "create", new_custom_name: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <div className="employee-popup-footer" style={{ marginTop: 10 }}>
                                    <button
                                        className="employee-btn employee-submit"
                                        onClick={handleResolveMappings}
                                        disabled={mappingLoading}
                                    >
                                        {mappingLoading ? "Resolving..." : "Save mappings & continue"}
                                    </button>

                                    <button
                                        className="employee-btn employee-cancel"
                                        onClick={() => {
                                            setShowCategoryMatchPopup(false);
                                            setFileParsedEmployees([]);
                                            setFileCategoryValues([]);
                                            setMismatchedCategories([]);
                                            setCategoryMappings({});
                                            setFileName("");
                                        }}
                                        style={{ marginLeft: 8 }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="employee-summary-wrapper">
                        <h2 className="employee-summary-title">Employee Summary</h2>

                        <div className="employee-summary-grid card">
                            {employeesToDisplay.length === 0 ? (
                                <p>No employees found.</p>
                            ) : (
                                getEmployeeSummary(employeesToDisplay).map((row, index) => (
                                    <div
                                        key={index}
                                        className="employee-summary-card"
                                        onClick={() => handleCategoryClick(row.cat_org_custom_name)}
                                        style={{ cursor: "pointer" }}
                                    >
                                        <h3>{row.cat_org_custom_name}</h3>
                                        <p>Employees: {row.count}</p>
                                    </div>
                                ))
                            )}
                        </div>

                        {/* Show table of employees when a category is clicked */}
                        {selectedCategory && employeesInCategory.length > 0 && (
                            <div className="employee-table-wrapper">
                                <h3>Employees in {selectedCategory}</h3>
                                <table>
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Employee ID</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Designation</th>
                                            <th>Phone</th>
                                            <th>Joining Date</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {employeesInCategory.map((emp, index) => (
                                            <tr key={emp.id || index}>
                                                <td>{index + 1}</td>
                                                <td>{emp.emp_id}</td>
                                                <td>{emp.emp_name}</td>
                                                <td>{emp.emp_email_id}</td>
                                                <td>{emp.designation}</td>
                                                <td>{emp.phone_number}</td>
                                                <td>{emp.joining_date ? emp.joining_date.split("T")[0] : ""}</td>

                                                <td>{emp.emp_status}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>

                </div>

                {showEditPopup && selectedEmployee && (
                    <div className="popup-overlay">
                        <div className="popup-card">
                            <h3>Edit Employee</h3>

                            <div className="form-row">
                                <div className="form-group">
                                    <label>Employee ID:</label>
                                    <input type="text" value={selectedEmployee.emp_id} disabled />
                                </div>

                                <div className="form-group">
                                    <label>Name:</label>
                                    <input
                                        type="text"
                                        value={selectedEmployee.emp_name || ""}
                                        onChange={(e) =>
                                            setSelectedEmployee({
                                                ...selectedEmployee,
                                                emp_name: e.target.value,
                                            })
                                        }
                                    />
                                </div>
                            </div>

                            <div className="form-row">
                                <div className="form-group">
                                    <label>Email:</label>
                                    <input
                                        type="email"
                                        value={selectedEmployee.emp_email_id || ""}
                                        onChange={(e) =>
                                            setSelectedEmployee({
                                                ...selectedEmployee,
                                                emp_email_id: e.target.value,
                                            })
                                        }
                                    />
                                </div>

                                <div className="form-group">
                                    <label>Designation:</label>
                                    <input
                                        type="text"
                                        value={selectedEmployee.designation || ""}
                                        onChange={(e) =>
                                            setSelectedEmployee({
                                                ...selectedEmployee,
                                                designation: e.target.value,
                                            })
                                        }
                                    />
                                </div>
                            </div>

                            <div className="form-row">
                                <div className="form-group">
                                    <label>Phone:</label>
                                    <input
                                        type="text"
                                        value={selectedEmployee.phone_number || ""}
                                        onChange={(e) =>
                                            setSelectedEmployee({
                                                ...selectedEmployee,
                                                phone_number: e.target.value,
                                            })
                                        }
                                    />
                                </div>

                                <div className="form-group">
                                    <label>Status:</label>
                                    <select
                                        value={selectedEmployee.emp_status || ""}
                                        onChange={(e) =>
                                            setSelectedEmployee({
                                                ...selectedEmployee,
                                                emp_status: e.target.value,
                                            })
                                        }
                                    >
                                        <option value="Active">Active</option>
                                        <option value="Inactive">Inactive</option>
                                    </select>
                                </div>
                            </div>

                            <div className="popup-buttons">
                                <button
                                    className="save-btn"
                                    onClick={() => handleUpdateEmployee(selectedEmployee)}
                                >
                                    Update
                                </button>
                                <button
                                    className="cancel-btn"
                                    onClick={() => setShowEditPopup(false)}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {showApprovalPopup && newOrgData && (
                    <div className="employee-popup-overlay">
                        <div className="employee-popup-container">
                            <div className="employee-popup-header">
                                <h3>Send Approval to Manager</h3>
                                <span
                                    className="employee-close-icon"
                                    onClick={() => setShowApprovalPopup(false)}
                                >
                                    &#10005;
                                </span>
                            </div>

                            <div style={{ padding: "10px" }}>
                                <label>Manager Email:</label>
                                <input
                                    type="email"
                                    value={managerEmail}
                                    onChange={(e) => setManagerEmail(e.target.value)}
                                    placeholder="Enter manager's email"
                                />
                            </div>

                            <div className="employee-popup-footer">
                                <button
                                    className="employee-btn employee-submit"
                                    onClick={() => handleSendApproval(newOrgData)}
                                    disabled={approvalSubmitting || !managerEmail}
                                >
                                    {approvalSubmitting ? "Sending..." : "Send for Approval"}
                                </button>
                            </div>
                        </div>
                    </div>
                )}
                <Footer />
            </main>
        </div>
    );
};

export default OrgSetup;
